import { Text, useToggle } from '@factorialco/deprecated-design-system'

import { ExplotableItem, ExplotableList } from 'modules/core/components/GroupingExplotable'

import type { SupplementType } from 'modules/payroll_bundle/components/common/helper/worksheet'
import { GroupProp } from 'modules/payroll_bundle/pages/SupplementsPage/BulkImport/_components/_Table/types'
import type Supplement from 'modules/payroll_bundle/store/models/Supplement'

import GroupBody from './_GroupBody'

interface Props {
  groups: GroupProp[]
  supplementTypes: SupplementType[]
  selected?: Set<number>
  checkable?: boolean
  onSelectItem?: (supplement: Supplement) => void
  onAssignEmployee: (userId: number, index: number) => void
}

type GroupProps = Pick<
  Props,
  'supplementTypes' | 'checkable' | 'selected' | 'onAssignEmployee' | 'onSelectItem'
> & { group: GroupProp }

const ExplotableGroup = ({
  group,
  supplementTypes,
  checkable,
  selected,
  onAssignEmployee,
  onSelectItem,
}: GroupProps) => {
  const [open, toggle] = useToggle(true)

  return (
    <ExplotableItem
      key={group.name}
      bottomRadius={false}
      dropDownAnimated={false}
      expandIcon="caret"
      headerBorders={false}
      headerRounded={false}
      opened={open}
      renderHeader={() => (
        <Text.Normal size="200" weight="medium" color="grey800">
          {`${group.name} (${group.count})`}
        </Text.Normal>
      )}
      scrollLimited={false}
      size="small"
      toggle={open ? toggle(false) : toggle(true)}
      type="primary"
    >
      <GroupBody
        supplements={group.supplements}
        supplementTypes={supplementTypes}
        selected={selected}
        checkable={checkable}
        onSelectItem={onSelectItem}
        onAssignEmployee={onAssignEmployee}
      />
    </ExplotableItem>
  )
}

const SupplementsGroups = ({
  groups,
  supplementTypes,
  selected,
  checkable,
  onSelectItem,
  onAssignEmployee,
}: Props) => {
  return (
    <ExplotableList>
      {groups.map((group) => {
        if (group.count > 0) {
          return (
            <ExplotableGroup
              key={group.name}
              group={group}
              supplementTypes={supplementTypes}
              selected={selected}
              checkable={checkable}
              onSelectItem={onSelectItem}
              onAssignEmployee={onAssignEmployee}
            />
          )
        }
      })}
    </ExplotableList>
  )
}

export default SupplementsGroups
